import PropTypes from 'prop-types';
import {
    CLOSED_STATE,
    getNextState,
    getButtonTranslationKey,
    getButtonStateClass
} from '../../../../../../../_modules/reviews/toggle_list_items';
import Translation from '../../../../../translation/translation';

const PropTyes = {
    reviewCount: PropTypes.number.isRequired,
    onChange: PropTypes.func
};

class ListToggleButton extends React.Component {
    static get propTyes() {
        return PropTyes;
    }

    constructor(props) {
        super(props);

        this.state = {
            buttonState: CLOSED_STATE
        };
    }

    render() {
        var buttonBaseClassName = 'fsf-station__fitter-review-more-btn';
        var buttonStateClassName = getButtonStateClass(this.state.buttonState, buttonBaseClassName);

        return (
            <div className="fsf-station__fitter-review-more-btn-container">
                <button className={[buttonBaseClassName, buttonStateClassName].join(' ')} onClick={this.onClick.bind(this)}>
                    <Translation translationKey={getButtonTranslationKey(this.state.buttonState)} />
                </button>
            </div>
        );
    }

    onClick() {
        this.setState({
            buttonState: getNextState(this.state.buttonState, this.props.reviewCount)
        }, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.buttonState);
            }
        });
    }
}

export default ListToggleButton;
